/*
 * SharingDialog Messages
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.sharing.dialog';

export default defineMessages({
  invitePeople: {
    id: `${scope}.invitePeople`,
    defaultMessage: 'Invite People',
  },
  inputPlaceholder: {
    id: `${scope}.inputPlaceholder`,
    defaultMessage: 'Type a name to invite',
  },
  doneLabel: {
    id: `${scope}.doneLabel`,
    defaultMessage: 'Done',
  },
  noResults: {
    id: `${scope}.noResults`,
    defaultMessage: 'No Results',
  },
  permissionOwner: {
    id: `${scope}.permissionOwner`,
    defaultMessage: 'Owner',
  },
  permissionContributor: {
    id: `${scope}.permissionContributor`,
    defaultMessage: 'Contributor',
  },
  permissionReviewer: {
    id: `${scope}.permissionReviewer`,
    defaultMessage: 'Reviewer',
  },
});
